import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
import { down } from "../../styles/breakpoints";
import {
  cardGrid,
  pageContentRoot,
  pageHeaderRow,
  pageShellRoot,
} from "../../styles/pageShell";

const useStyles = createUseStyles({
  contentMain: pageShellRoot,

  containerHeader: {
    ...pageHeaderRow,
    padding: "15px 0px",
  },

  vehiculeRoot: pageContentRoot,

  divApercu: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  divApercuFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  divApercu2: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "10px",
  },
  containerCompagnies: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "10px",
  },
  divTitle: {
    ...pageHeaderRow,
  },

  /* A grid instead of a wrapping flex row: company cards now share one
     column width and line up, rather than each sizing to its own label. */
  divCompagnies: cardGrid(240),
  /*
   * Mode liste : le tableau defile horizontalement plutot que de comprimer ses
   * colonnes. Un numero d'immatriculation coupe en deux ne sert a rien, et
   * c'est souvent la colonne qu'on vient lire.
   */
  tableWrap: {
    width: "100%",
    overflowX: "auto",
  },
  rowMuted: {
    fontSize: 11,
    opacity: 0.6,
  },
  rowMono: {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: 13,
  },
  /*
   * Etat vide explicite. Une grille vide ressemble a un chargement bloque,
   * surtout apres un clic sur "Archivees" -- il faut dire que le filtre a
   * fonctionne et qu'il n'y a rien dedans.
   */
  emptyState: {
    padding: "40px 20px",
    textAlign: "center",
    fontSize: 14,
    opacity: 0.7,
  },

  divSociety: {
    borderRadius: "10px",
    padding: "17px 20px",
    display: "flex",
    flexDirection: "row",
    gap: "25px",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: 0,
    backgroundColor: colors.WHITE,
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.10)",
    [down.sm]: {
      gap: "12px",
      padding: "14px 16px",
    },
  },
  /* `minWidth: 0` lets long company names ellipsise instead of stretching
     the card past the grid column. */
  divText: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
    overflowWrap: "anywhere",
  },
  divIcon: {
    cursor: "pointer",
  },
});

export default useStyles;
